module.exports = __webpack_public_path__ + "media/video.b9961477.mp4";